<template>
    <OverlayLoader :isLoading="!paymentsLoaded">
        <main class="page page-dashboard">
            <div class="container">
                <PageHeader
                    :title="$translate.text('general.payments')"
                />

                <div class='form-group'>

                    <div style='position: relative; display: inline-block'>
                        <input
                            type="text"
                            v-model="search"
                            placeholder="zoeken"
                            @blur='getPayments'
                            @keyup.enter='getPayments'
                        />

                        <i class="fa fa-search" style='position: absolute; right: 20px; top: 12px; cursor: pointer;' @click='getPayments'></i>
                    </div>

                    <input
                        type="date"
                        v-model='dates.from'
                        placeholder="van"
                    />

                    <input
                        type="date"
                        v-model='dates.until'
                        placeholder="tot"
                    />

                    <button class="button button--rounded" @click='downloadSepa'>SEPA export</button>
                    <button class="button button--rounded" @click='downloadExcel' style='margin-left: 10px;'>EXCEL export</button>
                </div>

                <WhiteTable :labels="[$translate.text('general.date'), $translate.text('general.company.name'), $translate.text('general.reseller'), $translate.text('general.subscription.option'), $translate.text('general.payment.reference'), $translate.text('general.price'), $translate.text('general.payment_interval'), $translate.text('general.status'), $translate.text('general.exported')]">
                    <template slot="table-data">
                        <tr v-for="payment in payments" :key="payment.id">
                            <td>{{ payment.meta.created_at }}</td>
                            <td>{{ payment.client.company_name }}</td>
                            <td>{{ payment.client.reseller.company_name }}</td>
                            <td>{{ payment.subscription_option.type === 'yearly' ? 'Jaar' : 'Eenmalig' }} ({{ payment.subscription_option.max_sync }})</td>
                            <td>{{ payment.payment_id }}</td>
                            <td>€ {{ payment.order ? payment.order.calculated_price : '' }}</td>
                            <td>{{ payment.payment_interval === 'year' ? 'Per jaar' : 'Per maand' }}</td>
                            <td>{{ payment.status }}</td>
                            <td>{{ payment.exported ? 'Ja' : 'Nee' }}</td>
                            <td class="align-right">
                                <i class="fal fa-eye" @click="$router.push({ name: 'Admin Payment Details', params: { id: payment.id } })"></i>
                            </td>
                        </tr>
                        <tr v-if="!payments.length">
                            <td colspan="10">{{ t('general.no_results_found') }}</td>
                        </tr>
                    </template>
                </WhiteTable>
            </div>
        </main>
    </OverlayLoader>
</template>
<script>
import handleError from '@/helpers/error';
import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';
import PageHeader from '@/components/PageHeader/PageHeader';
import WhiteTable from '@/components/Table/WhiteTable';
import debounce from 'lodash/debounce';

export default {
    name: 'AdminPayments',

    components: {
        PageHeader,
        OverlayLoader,
        WhiteTable,
    },

    data() {
        return {
            payments: [],
            paymentsLoaded: false,

            dates: {
                from: null,
                until: null,
            },

            search: null,
        };
    },

    created() {
        this.getPayments();
    },

    methods: {
        getPayments() {
            this.paymentsLoaded = false;

            this.API.admin.payments.index({ search: this.search, ...this.dates })
                .then((response) => {
                    const data = response.data.data;
                    this.payments = data;
                    this.paymentsLoaded = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        downloadSepa() {
            this.API.admin.payments.exportSepa({ search: this.search, ...this.dates })
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: 'text/xml',
                    });

                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'payouts.xml';
                    link.click();

                    this.getPayments();
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        downloadExcel() {
            this.API.admin.payments.exportCsv({ search: this.search, ...this.dates })
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: 'text/csv',
                    });

                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'payouts.csv';
                    link.click();
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },
    },

    watch: {
        dates: {
            handler: debounce(function () {
                this.getPayments();
            }, 1000), // Adjust debounce delay (in ms) as needed
            deep: true,
        },
    },
};
</script>

<style scoped>
    .white-table {
        padding-top: 20px;
    }

    input {
        flex: 6;
        border: 0;
        border-radius: 4px;
        padding: 12px 16px;
        font-size: 16px;
        margin-right: 10px;

        &:disabled {
            background-color: darken(#fff, 5%);
            cursor: not-allowed;
        }
    }
</style>
